// sneaky declare for avoiding compile error.
declare global {
  const __VERSION__: {};
}

// __VERSION__ will get converted to actual version object by the webpack plugin.
export const version = __VERSION__;
